<script>
export default
{
    name: 'mv-main-page-gallery-form',

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label class="col-md-4 control-label">
                Címke HU
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.label_hu">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                Címke EN
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.label_en">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGE') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" @upload-done="addFile($event)" accept="image/*"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">
            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/MainPageGalleryForm.vue